import IOrderDetails from '../interfaces/OrderDetails';
import PostPaymentContextResponse from '../interfaces/PostPaymentContextResponse';
import PostPayorderContextPayload from '../interfaces/PostPayorderContextPayload';
import PostPayorderContextResponse from '../interfaces/PostPayorderContextResponse';
import {
  IPostPayorderLinkError,
  IPostPayorderLinkPayload,
  IPostPayorderLinkResponse,
} from '../interfaces/PostPayorderLink';
import { getCountryCode, getLanguageCode } from '../utils/localization';

import makeFetchClient from './makeFetchClient';

const api = makeFetchClient(window.payorder.API_CLIENT_ID);
const url = (path: string) =>
  `${window.payorder.PAYORDER_API_URL}/${getCountryCode()}/${getLanguageCode()}/${path}`;

export function postPayorderContext(payload: PostPayorderContextPayload) {
  return api.post<PostPayorderContextResponse>(url('context'), payload);
}

export function getOrderDetails(payorderContextId: string) {
  return api.get<IOrderDetails>(url(`contexts/${payorderContextId}`));
}

export function postPaymentContext(payorderContextId: string, turnstileToken?: string) {
  return api.post<PostPaymentContextResponse>(
    url(`contexts/${payorderContextId}/payment`),
    turnstileToken ? { cfTurnstile: turnstileToken } : {},
  );
}

export function postPayOrderLink(payload: IPostPayorderLinkPayload) {
  return api.post<IPostPayorderLinkResponse | IPostPayorderLinkError>(url(`link`), payload);
}
